import React from 'react'
import { cn } from '~/lib/utils'
import { TimeIcon } from '~/components/ActionPlan/TrackTileComponents/icons'
import { AddedIcon } from './icons'
import { itemTypeIconMap } from '~/components/ActionPlan/TrackTileComponents/ActiveTile'

const ResourceTile = ({
  title,
  status,
  description,
  time,
  type,
  withBorder,
  skipped_by_candidate,
  skipped_by_coach,
  completed,
  added_by_coach,
  children,
}) => {
  const statusStyles = completed
    ? 'bg-willow-brook-100 text-intoo-green-coachcta'
    : skipped_by_candidate
      ? 'bg-yellow-100 text-yellow-800'
      : skipped_by_coach
        ? 'bg-blue-100 text-blue-800'
        : 'bg-gray-100 text-gray-700'

  return (
    <div className={withBorder ? 'mb-4 border-b border-[#B9B9B9] pb-4' : ''}>
      <div className="mb-2 flex items-center">
        <p className="pr-3 font-semibold">{title}</p>
        {status && (
          <span
            className={cn(
              'rounded-[5px] p-2 text-base font-medium',
              statusStyles,
            )}
          >
            {status}
          </span>
        )}
      </div>
      <div className="flex items-start justify-between gap-x-8">
        <p className="mb-3 mt-2">{description}</p>
        {children}
      </div>
      <TimeAndType time={time} type={type} addedByCoach={added_by_coach} />
    </div>
  )
}

export default ResourceTile

const TimeAndType = ({ time, type, addedByCoach }) => {
  const icon = itemTypeIconMap[type] || null
  return (
    <div className="flex md:flex-row">
      <div className="flex flex-col items-center justify-center gap-2 border-r border-cod-gray-200 pr-4">
        <TimeIcon variant="coach" />
        <div className={'capitalize text-intoo-green-coachcta'}>{time}</div>
      </div>
      <div className="flex flex-col items-center justify-center gap-2 px-4">
        {icon &&
          React.cloneElement(icon, {
            className: 'text-intoo-green-coachcta',
            height: '24',
          })}
        <div className={`capitalize text-intoo-green-coachcta`}>
          {type.split('_').join(' ')}
        </div>
      </div>
      {addedByCoach && (
        <div className="flex flex-col items-center justify-center gap-2 border-l border-cod-gray-200 pl-4">
          <AddedIcon />
          <p className="text-intoo-green-coachcta">Coach Added</p>
        </div>
      )}
    </div>
  )
}
